var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"position":"relative"}},[(_vm.currentwidth < 850)?_c('div',[_c('h5-index',{attrs:{"navlist":_vm.navlist,"list":_vm.list,"step":_vm.step,"swipes":_vm.swipes,"cwidth":_vm.currentwidth}})],1):_c('div',[_c('web-index',{attrs:{"navlist":_vm.navlist,"list":_vm.list,"step":_vm.step,"swipes":_vm.swipes}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }